const DEFAULT_DATA = {
  hero: {
    badge: 'VARLIK YÖNETİMİ ÇÖZÜMLERİ',
    badge_en: 'ASSET MANAGEMENT SOLUTIONS',
    title: 'Medya ve Veri Taşıyıcı Güvenliği',
    title_en: 'Media & Data Carrier Security',
    description:
      'ISO 27001:2022 Ek-A kontrolleri kapsamında, USB sürücüler, yedekleme bantları ve diğer fiziksel veri taşıyıcılarının uçtan uca güvenliğini ve takibini merkezileştirin.',
    description_en:
      'Centralize end-to-end security and tracking of USB drives, backup tapes, and other physical data carriers under ISO 27001:2022 Annex-A controls.',
    primaryButtonText: 'Envanteri Başlat',
    primaryButtonText_en: 'Start Inventory',
    secondaryButtonText: 'Dökümantasyon',
    secondaryButtonText_en: 'Documentation',
    image: null,
    gorselPozisyon: 'sag',
  },

  statsSection: {
    stats: [
      {
        label: 'KAYITLI MEDYA',
        label_en: 'REGISTERED MEDIA',
        value: '124',
        small: 'Birim',
        small_en: 'Units',
        sub: 'Güncel envanter',
        sub_en: 'Up-to-date inventory',
        smallRenk: 'text-[#4a6b63]',
      },
      {
        label: 'ŞİFRELEME ORANI',
        label_en: 'ENCRYPTION RATE',
        value: '%100',
        small: 'Tam Uyum',
        small_en: 'Full Compliance',
        sub: 'ISO 27001 uyumlu koruma',
        sub_en: 'ISO 27001 compliant protection',
        smallRenk: 'text-[#4a6b63]',
      },
      {
        label: 'SON İMHA PERİYODU',
        label_en: 'LAST DISPOSAL PERIOD',
        value: '12.05',
        small: '2024',
        small_en: '2024',
        sub: 'Bir sonraki planlanan: 12.11.2024',
        sub_en: 'Next scheduled: 12.11.2024',
        smallRenk: 'text-[#4a6b63]',
      },
    ],
  },

  features: {
    Title: 'Güvenlik Özellikleri ve Kontroller',
    Title_en: 'Security Features & Controls',
    Description:
      'Fiziksel veri taşıyıcılarını güvenli şekilde yönetmek için ihtiyaç duyduğunuz temel yetenekler.',
    Description_en:
      'Core capabilities you need to manage physical data carriers securely.',
    cards: [
      {
        icon: 'FaUsb',
        title: 'Çıkarılabilir Medya Kontrolü',
        title_en: 'Removable Media Control',
        description:
          'Yetkisiz veri transferini engellemek için USB ve port erişimlerini merkezi ilkelerle kısıtlayın ve izleyin.',
        description_en:
          'Restrict and monitor USB and port access with central policies to prevent unauthorized data transfers.',
      },
      {
        icon: 'FaLock',
        title: 'Şifreleme Gereksinimleri',
        title_en: 'Encryption Requirements',
        description:
          'Tüm taşınabilir medyaların AES-256 standardında şifrelenmesini zorunlu tutan politikaları devreye alın.',
        description_en:
          'Enforce policies requiring AES-256 encryption for all removable media.',
      },
      {
        icon: 'FaTrashAlt',
        title: 'Güvenli İmha Süreçleri',
        title_en: 'Secure Disposal Processes',
        description:
          'Kullanım ömrü dolan yedekleme bantları ve disklerin geri dönülemez şekilde imha edilmesini takip edin.',
        description_en:
          'Track the irreversible disposal of end-of-life backup tapes and disks.',
      },
      {
        icon: 'FaClipboardList',
        title: 'Fiziksel Medya Envanteri',
        title_en: 'Physical Media Inventory',
        description:
          'Seri numarası, fiziksel konum ve sorumlu ataması ile tüm veri taşıyıcı envanterinizi güncel tutun.',
        description_en:
          'Keep your entire data carrier inventory up to date with serial number, physical location, and owner assignment.',
      },
    ],
  },

  cta: {
    Title: 'ISO 27001 Uyumluluğunuzu Kanıtlayın',
    Title_en: 'Prove Your ISO 27001 Compliance',
    Description:
      'Medya güvenliği denetimlerinde tam hazır olun. RUZY ile her veri taşıyıcısının yaşam döngüsünü raporlayın.',
    Description_en:
      'Be fully prepared for media security audits. Report the lifecycle of every data carrier with RUZY.',
    primaryButtonText: 'Ücretsiz Deneyin',
    primaryButtonText_en: 'Try for Free',
    secondaryButtonText: 'Satışla Görüşün',
    secondaryButtonText_en: 'Talk to Sales',
  },
};

export default DEFAULT_DATA;